// extracted by mini-css-extract-plugin
export default {"container":"MandatoryInfoBox-module__container-hy6H","extraMargin":"MandatoryInfoBox-module__extraMargin-Y_r8"};